<template>
  <div>
    <div class="person-box" :class="{ mobile :isMobile}">
      <div class="close-box">
        <i class="close iconfont icon-close-o" @click="$emit('update:show',false)"></i>
      </div>
      <div class="content" v-html="row.ext.spotTextIntro"></div>
    </div>
    <div class="mask"></div>
  </div>

</template>

<script>
	export default {
		props: {
			show: {
				type: Boolean,
				default: false
			},
			row: {
				type: Object,
				default: null
			}
		},
	}
</script>

<style scoped>
  .person-box{
    position: fixed;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    background: #fff;
    z-index: 2000;
    border-radius: 4px;
    width: 800px;
    min-height:100px;
    max-height: 80%;
    display: flex;
    flex-direction: column;
    padding-bottom: 30px;
  }

  .close-box{
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .close{
    width: 50px;
    height: 50px;
    font-size: 18px;
    cursor: pointer;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .person-box .content{
    flex:1;
    min-height: 0;
    padding: 0 30px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .person-box.mobile{
    width: 80%;
    padding-bottom: 15px;
  }

  .person-box.mobile .content{
    padding: 0 15px;
  }

  .mask{
    position: fixed;
    left:0;
    top:0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 1999;
  }

  .title{
    position: relative;
  }

  .title .label{
    position: absolute;
    color: #f00;
    left:0;
    top:5px;
  }
</style>
